import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


// ** Fetch Users
export const fetchInspirationsThunk = createAsyncThunk(
  "fetchInspirations",
  async (params, config) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_LOCAL}/api/inspirations/fetchAll`,
      params
    );

    return response.data;
  }
);

export const createInspirationsThunk = createAsyncThunk(
  "createInspirations",
  async (data) => {

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_LOCAL}/api/inspirations/create`,
      data
    );

    return response.data;
  }
);

// delete Inspirations
export const deleteInspirationThunk = createAsyncThunk(
  "deleteInspiration",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/inspirations/delete/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error deleting Inspiration");
    }
  }
);

//   update Inspiration 
  export const updateInspirationThunk = createAsyncThunk(
    "updateTattoo",
    async ({ id, values }, { rejectWithValue }) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL_LOCAL}/api/inspirations/update/${id}`,
          values
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Error updating tattoo");
      }

  }
);

// update order for shuffle data
export const updateInspirationsPositionThunk = createAsyncThunk(
  "updateInspirationsPosition",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/inspirations/shuffleData`, { id: id.order });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const sortInspirationsThunk=createAsyncThunk(
  "sortInspirations",
  async ({ id,isSorted }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/inspirations/sort`,
        { id,isSorted }  // Ensuring correct API parameter
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating order");
    }
  }
)

export const AdminCreateInspirationsThunk = createAsyncThunk(
  "adminCreateInspirations",
  async (data) => {

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_LOCAL}/api/inspirations/admin/create`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;
  }
);


export const inspirationSlice = createSlice({
  name: "inspiration",
  initialState: {
    inspirations: "",
    total: 0,
    limit: 10,
    page: 1,
    pageCount: 0,
    isLoading: true,
  },
  reducers: {
    changeLimit: (state, action) => {
      state.limit = action.payload;
    },
    changePage: (state, action) => {
      state.page = action.payload;
    },
    updateOrder: (state, action) => {
      state.inspirations = action.payload; // Update state immediately on drag
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInspirationsThunk.fulfilled, (state, action) => {
      state.inspirations = action?.payload?.data?.inspiration
      state.total = action?.payload?.data?.totalCount
      state.page = action?.payload?.data?.currentPage
      state.pageCount = action?.payload?.data?.totalPages

      state.isLoading = true;
      if (action?.payload?.code === 200) {
        state.users = action.payload?.body.users;
        state.total = action.payload?.body.total;
        state.isLoading = false;
      }
    }).addCase(createInspirationsThunk.fulfilled, (state, action) => {
      // state.inspirations=action?.payload?.data?.inspiration
      // state.total=action?.payload?.data?.totalCount
      // state.page=action?.payload?.data?.currentPage
      // state.pageCount=action?.payload?.data?.totalPages

      // state.isLoading = true;
      // if (action?.payload?.code === 200) {
      //     state.users = action.payload?.body.users;
      //     state.total = action.payload?.body.total;
      //     state.isLoading = false;
      // }
    });


  },
});

export const { changeLimit, changePage, updateOrder } = inspirationSlice.actions;
export default inspirationSlice.reducer;
